import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const Influencers = () =>
  import(/* webpackChunkName: "influencers-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/influencers',
    name: 'influencers',
    component: Influencers,
    meta: {
      title: 'Influencers',
      auth: {
        roles: [ADMIN], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/error', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
